import makeInvokeBackendFunction from './makeInvokeBackendFunction.js';

export default function sendAppRegistrationCode(app) {
  const req = { domainName: 'account.octopus-esm.com' };

  return async (email, isCodeAuthentication = false) => {
    const invokeFunction = makeInvokeBackendFunction(req);
    const result = await invokeFunction(
      'send-app-registration-code',
      { email, isCodeAuthentication, appId: app.id },
      'POST'
    );

    return result.data;
  };
}
